<template>
  <div
    class="box"
    :class="{ shadow, 'shadow-hover': shadowHover }"
  >
    <div
      v-if="title || hasSlot('header')"
      class="box-header"
      :class="boxHeaderClasses"
      @click="toggleCollapsed()"
    >
      <slot
        name="header"
        :title="title"
      >
        <h3
          v-if="title"
          class="box-title"
          :style="{ color: headerTextColorVariant === 'light' ? 'white' : 'inherit' }"
          v-text="title"
        />
      </slot>
      <div
        v-if="hasSlot('header-right')"
        class="header-right"
      >
        <slot name="header-right" />
      </div>
      <div
        v-if="canCollapsed"
        class="collapse-btn"
      >
        <i
          class="fa"
          :class="[`fa-arrow-${collapsed ? 'down' : 'up'}`]"
        />
      </div>
      <div class="clearfix" />
      <hr
        v-if="headerDivider"
        style="margin-bottom: 0;"
      >
    </div>

    <transition name="fade">
      <div
        v-show="!collapsed"
        class="box-body"
        :class="{ 'box-body-collapsed': collapsed, 'without-left-padding': withoutLeftPadding }"
      >
        <slot />
      </div>
    </transition>

    <div
      v-if="hasSlot('footer')"
      class="box-footer"
    >
      <slot name="footer" />
    </div>
    <c-loading-overlay v-if="loading" />
  </div>
</template>

<script>
import slotsMixin from '../../mixins/slots'
import CLoadingOverlay from './CLoadingOverlay'
import grid from '../../mixins/grid'

export default {
  name: 'CBox',
  components: {
    CLoadingOverlay
  },
  mixins: [slotsMixin, grid],
  props: {
    /**
     * Заголовок.
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Статус загрузки.
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Тень по границам.
     */
    shadow: {
      type: Boolean,
      default: false
    },
    /**
     * Тень по границам при наведении.
     */
    shadowHover: {
      type: Boolean,
      default: false
    },
    /**
     * Цвет фона хедера.
     *
     * @values success, warning, danger
     */
    headerBackgroundVariant: {
      type: String,
      validator (value) {
        return ['success', 'warning', 'danger'].includes(value) || value === ''
      },
      default: ''
    },
    /**
     * Цвет текста хедера.
     *
     * @values dark, light
     */
    headerTextColorVariant: {
      type: String,
      validator (value) {
        return ['dark', 'light'].includes(value) || value === ''
      },
      default: 'dark'
    },
    /**
     * Добавляет горизонтальный разделитель после хедера.
     */
    headerDivider: {
      type: Boolean,
      default: false
    },
    /**
     * Добавляет функционал сворачивания содержимого. Работает только при ширине экрана <768px.
     */
    collapsable: {
      type: Boolean,
      default: false
    },
    /**
     * Без внутреннего отступа слева
     */
    withoutLeftPadding: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      collapsed: false
    }
  },
  computed: {
    /**
     * Классы для блока заголовка.
     *
     * @returns {[]}
     */
    boxHeaderClasses () {
      const classes = []

      if (this.headerBackgroundVariant) {
        classes.push(`background-${this.headerBackgroundVariant}`)
      }

      if (this.collapsed) {
        classes.push('rounded')
      }

      if (this.withoutLeftPadding) {
        classes.push('without-left-padding')
      }

      return classes
    },
    /**
     * Доступен ли функционал сворачивания содержимого.
     *
     * @returns {boolean}
     */
    canCollapsed () {
      return this.collapsable && this.gridXs
    }
  },
  mounted () {
    if (this.canCollapsed) {
      this.collapsed = true
    }
  },
  methods: {
    /**
     * Переключает состояние свернуто/развернуто для содержимого.
     */
    toggleCollapsed () {
      if (this.canCollapsed) {
        this.collapsed = !this.collapsed
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables";

.rounded {
  border-radius: $borderRadiusLarge $borderRadiusLarge $borderRadiusLarge $borderRadiusLarge !important;
}

.collapse-btn {
  position: absolute;
  top: 20px;
  right: 20px;
}

.header-right {
  float: right;

  @media (max-width: $xsBreakpoint) {
    float: none;
    margin-top: 15px;
  }
}
</style>
